const KEY = "rh.playback";
export const DEFAULT_PLAYBACK = { crossfade: 3, gaplessAlbums: true, lyricsOffset: 0 };
export const CROSSFADE_MAX = 12;

export const loadPlayback = () => {
  try { return { ...DEFAULT_PLAYBACK, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return { ...DEFAULT_PLAYBACK }; }
};
export const savePlayback = (p) => localStorage.setItem(KEY, JSON.stringify(p));

// consecutive songs of the same album play seamlessly (no fade) — live albums, DJ mixes, concept albums
export const isContinuation = (cur, nxt, nextIndex, curIndex, shuffle) =>
  !!(cur?.album_id && nxt?.album_id && cur.album_id === nxt.album_id && nextIndex === curIndex + 1 && !shuffle);

export const fadeCurve = (p) => ({ out: Math.cos((p * Math.PI) / 2), in: Math.sin((p * Math.PI) / 2) });
